import {createContext, ReactNode} from "react";
import {AppPermissions} from "../model/Group";

export interface TokenContextInterface {
    token: string|null,
    roles: AppPermissions[],
}

const initialState: TokenContextInterface = {
    token: null,
    roles: [],
};

export const TokenContext = createContext<TokenContextInterface>(initialState);

export const TokenContextProvider = ({token, roles, children}: {token: string | null, roles: AppPermissions[], children: ReactNode}) => {

    const value = {
        token: token,
        roles
    };

    return <TokenContext.Provider value={value} children={children}/>
}